window.authorPage = function() {
    const slickSlider = () => {
        $('.-sauthor').slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 500,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            autoplay: false,
            autoplaySpeed: 2000,
            responsive: [{
                breakpoint: 960,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            }
            ]
        });
    }

    const init = () => {
        window.sortFirstLetters = function(elem, charachter) {
            let url = window.location.href.split('?')[0];
                url += '?page=1';
        
            $.ajax({
                url: url,
                dataType: 'html',
                type: "POST",
                data: {
                    terms: charachter,
                },
            })
            .done(function(response) {
                $('.authorSort__btn').removeClass('active');
                $(elem).addClass('active');
        
                $('#list-ajax').html(response);
                $('html, body').animate({
                    scrollTop: $("#list-ajax").parent().parent().offset().top
                }, 1000);
        
                var refresh = window.location.protocol + "//" + window.location.host + window.location.pathname +'?page=1';  
                window.history.pushState({ path: refresh }, '', refresh);
            })
            .fail(function(xhr, textStatus, errorThrown) {
                console.log(errorThrown);
            });
        }
    };

    const paginate = () => {
        $(document).on('click', '#pagination-author-list a', function(event) {
            let charachter = $('.button.authorSort__btn.active').data('value');

            let url = $(this).attr('href');
            window.history.pushState({}, null, url);

            $.ajax({
                type: 'POST',
                url: url,
                data: { 
                    terms: charachter
                },
                success:function(response) {
                    $('#list-ajax').html(response);
                    $('html, body').animate({
                        scrollTop: $("#list-ajax").parent().parent().offset().top
                    }, 1000);
                }
            });
            
            return false;
        })
    };
    
    return {
        init: function() {
            slickSlider();
            init();
            paginate();
        }
    };
}();

window.detailPage = function() {
    const init = () => {};
    
    return {
        init: function() {
            init();
        }
    };
}();

window.illustratorForm = function() {
    const formSubmsission = () => {
        $("form").each(function() {
            $(this).validate({
                rules: {
                    name: {
                        required: true,
                        maxlength: 255,
                    },
                    email: {
                        required: true,
                        email: true,
                    },
                    portfolio_link: {
                        required: true,
                        url: true,
                    },
                },
                errorPlacement: function(error, element) {
                    error.insertAfter(element);
                },
                highlight: function (element) {
                    $(element).closest('.formInput').addClass('formError');
                },
                unhighlight: function(element) {
                    $(element).closest('.formInput').removeClass('formError');
                },
                errorElement: 'div',
                errorClass: 'formError__txt',
            });
        });
    };
    
    return {
        init: function() {
            formSubmsission();
        }
    };
}();